// uses react-helmet that manages <head>...</head> information of a page
// Page Title
// page title is the main link text for your website that shows up in google
// length of page title:
// Meta Description
// meta description is the short snipit of text that shows up under your website's
// link and page title
// length of meta description: about 155 - 160 characters, can be more
// also creates indicates its canonical url as itself with the <link> tag
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import {
  pageTitleType,
  metaDescriptionType,
  promptLookingforType
} from '../../types';

const HeadManager = ({
  pageTitle,
  metaDescription,
  promptLookingfor,
  canonicalPath
}) => {
  const location = useLocation();
  // Prefer an explicit canonical path (e.g. the prompt's true id/slug URL) so
  // that alternate slugs like /prompt/{id}/anything don't each self-canonicalize
  // into a duplicate. Fall back to the current pathname for pages that don't
  // pass one.
  const canonicalPathname = canonicalPath || location.pathname;
  const url = `https://eropenpal.com${canonicalPathname}`;
  const renderTitle = () => {
    if (url.includes('/prompt/')) {
      return (
        <title>{`${promptLookingfor} ${pageTitle} - EroPenPal: Erotic Roleplay and Naughty Penpals`}</title>
      );
    }
    if (url.includes('/user/')) {
      return (
        <title>{`${pageTitle} - User Profile - EroPenPal: Erotic Roleplay and Naughty Penpals`}</title>
      );
    }
    if (url.includes('/tag/')) {
      return (
        <title>{`${pageTitle} - Tag Page - EroPenPal: Erotic Roleplay and Naughty Penpals`}</title>
      );
    }
    return (
      <title>{`${pageTitle} - EroPenPal: Erotic Roleplay and Naughty Penpals`}</title>
    );
  };

  return (
    <Helmet>
      {renderTitle()}
      <link rel="canonical" href={url} />
      {metaDescription && (
        // Helmet escapes attribute values itself; manually replacing " with
        // &quot; here double-escapes and renders literal &quot; in snippets.
        <meta name="description" content={metaDescription} />
      )}
    </Helmet>
  );
};

HeadManager.propTypes = {
  pageTitle: pageTitleType.isRequired,
  metaDescription: metaDescriptionType,
  promptLookingfor: promptLookingforType,
  canonicalPath: PropTypes.string
};

HeadManager.defaultProps = {
  metaDescription: null,
  promptLookingfor: null,
  canonicalPath: null
};

export default HeadManager;
